export default "__VITE_ASSET__2c6eb2da__"